import { useCallback } from "react";
import { LicenseManagerApi, useAPIAction } from "melco-shared-logic";

export const useUpdateEmail = () => {
  const [updateEmail] = useAPIAction(
    LicenseManagerApi,
    async (api, newEmailAddress: string, serialNumber: string) => {
      const data = await api.licenseManagerLicensesManagerEmail({
        controlcenterMelcoModelsBridgeSerialNumber: {
          new_email_address: newEmailAddress,
          serial_number: serialNumber,
        },
      });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "licenses.basic.detail.editemail",
    }
  );

  return useCallback(
    async (newEmailId: string, serialNumber: string) => {
      try {
        return await updateEmail(newEmailId, serialNumber);
      } catch (e) {
        // error handling is already done in useAPIAction
      }
    },
    [updateEmail]
  );
};
